<template>
  <div>
    <div class="banner">
      <div class="banner-box d-flex" >
        <div class="title-box">
          <div class="text-box">
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="d-md-flex justify-content-between my-4 anctors">
        <div class="my-2">
          <button type="button" @click="goAnchor('introduction', -100)" class="btn btn-danger m-auto" style="width:100%">測驗簡介</button>
        </div>
        <div class="my-2">
          <button type="button" @click="goAnchor('content', -100)" class="btn btn-danger m-auto" style="width:100%">題型內容</button>
        </div>
        <div class="my-2">
          <button type="button" @click="goAnchor('situation', -100)" class="btn btn-danger m-auto" style="width:100%">通過標準</button>
        </div>
        <div class="my-2">
          <button type="button" @click="goAnchor('guide', -100)" class="btn btn-danger m-auto" style="width:100%">認證基準</button>
        </div>
        <div class="my-2">
          <button type="button" @click="goAnchor('practice', -100)" class="btn btn-danger m-auto" style="width:100%">JLPT模擬考</button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="introduction">
            <h3 class="title pr-3">  {{ $t('Navbar.about_JLPT') }}</h3>
            <div class="line"></div>
          </div>
          <div>
          日本語能力試驗(JLPT-Japanese Language Proficiency Test)是從1984年由日本國際交流基金會與日本國際教育支援協會共同舉辦的。這是為了母語非日語的學習者所舉辦的日 語能力檢定測驗,通稱為日檢。每年在7月及12月各舉辦一次,除了在日本的外國人能參加測驗之外,在海外的日語學習者也可以查詢自己的國家地區是否有參加共同測驗就近報名 應考,共於約80個國家實施測驗,可說是世界最大規模之日語測驗。日語能力試驗的應試者來自各國,有些想測試自我日語能力,有些則是希望藉由通過測驗而順利畢業、求職、加 薪晉升、海外生活等。本測驗共分五個級數,由難至易依序為N1~N5,報考者可依自己的能力選擇適合的級數參加。日本語能力試驗測驗之成績,可作為學習評量、入學甄選及求職 時之日語能力證明。
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="content">
            <h3 class="title pr-3">題型內容</h3>
            <div class="line"></div>
          </div>
          <div class="row my-3">
            <img class="my-2" style="width:100%" src="../../assets/image/table/JLTP_content_N1.svg" alt="">
            <img class="my-2" style="width:100%" src="../../assets/image/table/JLTP_content_N2.svg" alt="">
            <img class="my-2" style="width:100%" src="../../assets/image/table/JLTP_content_N3.svg" alt="">
            <img class="my-2" style="width:100%" src="../../assets/image/table/JLTP_content_N4.svg" alt="">
            <img class="my-2" style="width:100%" src="../../assets/image/table/JLTP_content_N5.svg" alt="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="situation">
            <h3 class="title pr-3">通過標準</h3>
            <div class="line"></div>
          </div>
          <div class="row my-3">
            <img class="my-2" style="width:100%" src="../../assets/image/table/JLTP_fraction_N1N2N3.svg" alt="">
            <img class="my-2" style="width:100%" src="../../assets/image/table/JLTP_fraction_N4N5.svg" alt="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="guide">
            <h3 class="title pr-3">{{ $t('Home.Learning_Guides') }}</h3>
            <div class="line"></div>
          </div>
          <div class="row my-3">
            <img style="width:100%" src="../../assets/image/table/JLTP_capable.svg" alt="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="practice">
            <h3 class="title pr-3">JLPT模擬考</h3>
            <div class="line"></div>
          </div>
          <div class="d-md-flex justify-content-between my-4">
            <div class="p-2  rwd-hide" v-for="(item, index) in exams" :key="index" @click="goPage(item.id,item.view_id)">
              <button type="button" style="width:100%" class="btn btn-dark p-4">{{item.name}}</button>
            </div>
            <div class="rwd-show">
              <h4>
                為提供最佳應考體驗，本站JLPT模擬測驗，不適用於手機介面，僅開放桌機或筆電進行考試。
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../store/api'
export default {
  name: 'Raiders',
  components: {

  },
  data () {
    return {
      exams: null
    }
  },
  computed: {
  },
  mounted () {
    this.getExamData()
    this.scrollTop()
  },
  methods: {
    async getExamData () {
      const { data } = await api.get('/contents/exams?page=1&pageSize=10&type=simulation')
      this.exams = data.data
    },
    goPage (id, viewId) {
      this.$router.push({ name: 'Examination', params: { examId: id ,viewId: viewId } })
    },
    goAnchor(id, yOffset = 0) {
      const el = document.getElementById(id)
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({top: y, behavior: 'smooth'})
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/custom.scss";
  .banner {
    height: 60vh;
    background-image: url('../../assets/image/pic/JLTP_banner_LW.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .title-box {
      width: 50%;
      .text-box {
        width: 50%;
        margin: auto;
        h4 {
          line-height: 200px;
          text-align: center;
          font-size: 150px;
          font-weight: 900;
          color: #fff;
          -webkit-text-stroke: 1.5px rgb(0, 0, 0);
        }
      }
    }
  }
  @media(max-width: 1080px){
    .banner {
      background-position: 0 0;
      .banner-box {
        display: none !important;
      }
    }
  }
  .container {
    text-align: left;
  }
  .anctors {
    button {
      min-width: 150px;
      font-size: 1.2rem;
    }
  }
  .title {
    font-size: 1.5rem;
    font-weight: 800;
    color: #c95867;
    background-color: $white-color;
    z-index: 10;
  }
  .line {
    width: 100%;
    position: absolute;
    // left: 100%;
    top: 32px;
    border-top: black 1px solid;
  }
  .rwd-show {
    display: none;
  }
  @media screen and (max-width: 420px) {
    .rwd-hide {
      display: none !important;
    }
    .rwd-show {
      display: block;
    }
    .banner {
      height: 30vh;
      background-size: contain;
      background-image: url('../../assets/image/pic/JLTP_banner_SW.jpg');
    }
  }
</style>
